


















































































import { Vue, Component, Ref } from 'vue-property-decorator';
import { VForm } from '@/types/VForm';
import { formatErrorForNotification } from '@/utils/error';
import BankConfig from '@/domain/models/BankConfig';
import GenerateFeedback from '@/views/billingRemittance/components/GenerateFeedback.vue';
import BillingRemittanceRepository from '@/repositories/BillingRemittanceRepository';
import SelectOptions from '@/domain/interfaces/ISelectOptions';
import PreNegotiationModule from '@/stores/modules/PreNegotiationModule';
import { getModule } from 'vuex-module-decorators';
import BankSendTypeEnum from '../../paymentRemittances/enums/BankSendTypeEnum';

@Component({
  components: { GenerateFeedback },
})
export default class PreNegotiationGenerateRemittance extends Vue {
  @Ref('form') readonly form!: VForm;

  created() {
    this.loadCompanies();
  }

  public readonly preNegotiationModule: PreNegotiationModule = getModule(PreNegotiationModule);

  readonly billingRemittanceRepository: BillingRemittanceRepository =
    new BillingRemittanceRepository();

  readonly required = (v: string | number) => !!v || 'Campo obrigatório!';

  loading: boolean = false;
  loadingBank: boolean = false;
  public isBankSendTypeSelectedVanType: boolean = false;

  company: number = Number(undefined);
  companyOptions: Array<SelectOptions> = [];

  bank: number|null = null;
  banks: Array<BankConfig> = [];
  bankOptions: Array<SelectOptions<number>> = [];

  sendType = Number(undefined);
  sendTypesItems: Array<SelectOptions<number>> = [];

  get group(): number {
    return this.$session.get('company_group_id');
  }

  public get hasPermissionToShowBorderoNumberOnGenerateRemittance(): boolean {
    return this.$session.get(
      'user_config_autotoggle_remittance_confirm_message',
    );
  }

  changedBank(): void {
    this.sendTypesItems = [];
    this.sendType = Number(undefined);
    this.isBankSendTypeSelectedVanType = false;

    const bankSelected = this.banks.find((bank) => bank.id === this.bank);

    this.sendTypesItems = bankSelected?.send_types.map((type) => {
        const { id, description } = type;
        return { value: id, text: description };
      }) || [];
  }

  changedCompany(): void {
    this.sendTypesItems = [];
    this.sendType = Number(undefined);

    this.bank = null;
    this.banks = [];
    this.bankOptions = [];
    this.isBankSendTypeSelectedVanType = false;
    if (this.company) this.loadBanks(this.company);
  }

  changedSendType(): void {
    if (!this.sendType) {
      this.isBankSendTypeSelectedVanType = false;

      return;
    }

    const selectedBank = this.banks.find((bank) => this.bank === bank.id);

    if (!selectedBank) {
      this.isBankSendTypeSelectedVanType = false;

      return;
    }

    const selectedSendType = selectedBank.send_types.find(
      ({ id }) => id === this.sendType,
    );

    if (!selectedSendType) {
      this.isBankSendTypeSelectedVanType = false;

      return;
    }

    this.isBankSendTypeSelectedVanType = selectedSendType.send_type === BankSendTypeEnum.VAN;
    this.setRemittanceDataInPreNegotiationModule();
  }

  async loadCompanies(): Promise<void> {
    try {
      this.loading = true;

      this.companyOptions = await this.billingRemittanceRepository.getCompanies();
    } catch (error: any) {
      const message = formatErrorForNotification(error);
      this.$notification.error(message);
    } finally {
      this.loading = false;
    }
  }

  async loadBanks(company: number): Promise<void> {
    try {
      this.loadingBank = true;

      this.banks = await this.billingRemittanceRepository.getAllBanksConfig([
        company,
      ]);

      this.bankOptions = this.banks.map((bank) => {
        const {
          // eslint-disable-next-line camelcase
          banco, agencia, conta, name, id,
        } = bank;

        return {
          value: id,
          text: `${banco} ${agencia} ${conta} - ${name}`,
        };
      });
    } catch (error: any) {
      const message = formatErrorForNotification(error);
      this.$notification.error(message);
    } finally {
      this.loadingBank = false;
    }
  }

  public setRemittanceDataInPreNegotiationModule() {
    this.preNegotiationModule.setRemittanceData({
        bank_id: this.bank,
        company_id: this.company,
        send_type: this.sendType,
    });
  }
}
